module.exports = global["URLSearchParams"] = require("-!./url-search-params.node.js");